"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _utils = require("@superlogica/foundation/utils");

var _polished = require("polished");

var _styledComponents = require("styled-components");

var buttonThemefication = function buttonThemefication(color) {
  var hexa = (0, _utils.parseColor)(color);
  var theme = {
    solid: (0, _styledComponents.css)(["background:", ";color:", ";border:1px solid transparent;& svg{fill:", ";}&:hover{background:", ";color:", ";& svg{fill:", ";}}&:focus{box-shadow:0 0 0 4px ", ";}"], hexa, (0, _utils.textContrast)(hexa), (0, _utils.textContrast)(hexa), (0, _utils.hoverColor)(hexa), (0, _utils.textContrast)((0, _utils.hoverColor)(hexa)), (0, _utils.textContrast)((0, _utils.hoverColor)(hexa)), (0, _polished.rgba)(hexa, 0.25)),
    outline: (0, _styledComponents.css)(["background:transparent;color:", ";border:1px solid ", ";& svg{fill:", ";}&:hover{border-color:", ";background:", ";color:", ";& svg{fill:", ";}}&:focus{box-shadow:0 0 0 4px ", ";}"], hexa, hexa, hexa, hexa, hexa, (0, _utils.textContrast)(hexa), (0, _utils.textContrast)(hexa), (0, _polished.rgba)(hexa, 0.25)),
    ghost: (0, _styledComponents.css)(["background:transparent;color:", ";border:1px solid transparent;& svg{fill:", ";}&:hover{color:", ";& svg{fill:", ";}}&:focus{box-shadow:0 0 0 4px ", ";}"], hexa, hexa, (0, _utils.hoverColor)(hexa), (0, _utils.hoverColor)(hexa), (0, _polished.rgba)(hexa, 0.25)),
    link: (0, _styledComponents.css)(["background:transparent;color:", ";padding:0 !important;border:none !important;&:after{display:none !important;}& svg{fill:", ";}&:hover{color:", ";& svg{fill:", ";}}"], hexa, hexa, (0, _utils.hoverColor)(hexa), (0, _utils.hoverColor)(hexa)),
    disabled: (0, _styledComponents.css)(["background:", ";color:", ";border:1px solid transparent;& svg{fill:", ";}"], _tokens.colors.neutral100, _tokens.colors.neutral300, _tokens.colors.neutral300)
  };
  return theme;
};

var _default = buttonThemefication;
exports.default = _default;